import { Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { InputStyled } from "./form-item-string";
import { useAdvancedFormContext } from "../advanced-form";
import styled from "styled-components";

const ReadOnlySelectStyled = styled(Select)`
  .ant-select-selector {
    background: none !important;
  }

  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88) !important;
    background: none !important;
  }

  .ant-select-arrow {
    display: none;
  }
`

function FormItemRef({ value, onChange, readOnly, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  const [internalValue, setInternalValue] = useState<string>("")
  const { data } = typeData.query({ c: 10000, o: 0, f: "{}" }) as any;

  useEffect(() => {
    const elem = data?.items?.find(e => e.id === value);
    let internalValue = elem ? typeData.render(elem) : (value || (typeData.multiple ? [] : ""));
    setInternalValue(internalValue);
  }, [value, data?.items, typeData])

  const selectedRef = useMemo(() => (data?.items || []).find(v => typeData.render(v) === internalValue), [data?.items, internalValue, typeData]);

  const options = useMemo(() => (data?.items || []).map(elem => ({ value: typeData.getId(elem), label: typeData.render(elem) })), [data?.items, typeData])

  console.log("Ref internal value", internalValue, value);

  return (<>
    { !effectiveReadOnly &&
      <Select 
        disabled={readOnly}
        showSearch
        value={internalValue}
        onChange={(v: any) => { onChange(typeData.multiple ? v.map(iv => parseInt(iv)) : parseInt(v))}}
        options={options}
        mode={typeData.multiple ? "multiple" : undefined}
        filterOption={(input, option) =>
          `${(option?.label ?? '')}`.toLowerCase().includes(input.toLowerCase())
        }
        allowClear
      />}
   { effectiveReadOnly && !typeData.multiple && <InputStyled value={selectedRef ? typeData.render(selectedRef) : ""} readOnly />}
   { effectiveReadOnly && typeData.multiple && <ReadOnlySelectStyled value={value} options={options} disabled mode="multiple" />}
   </>
  )
}

export default FormItemRef;
